/*
* Based on autoComplete library
* https://goodies.pixabay.com/javascript/auto-complete/demo.html
*/

(function (root, factory) {
    if (typeof define === "function" && define.amd) {
        define("prFulltext", factory(root));
    } else if (typeof exports === "object") {
        module.exports = factory(root);
    } else {
        root.prFulltext = factory(root);
    }
})(window || this, function (root) {

    "use strict";

    /**
     * Variables
     */
    const prFulltext = {};
    let xhr,
        emptyData = { 'status': 'empty', 'items': [ { 'textLabel': '- ' + window.poskiLocale.fulltext_nofound + ' -', 'url': '' } ] },
        errorData = { 'status': 'error', 'items': [ { 'textLabel': '- ' + window.poskiLocale.fulltext_error + ' -', 'url': '' } ] },
        options = {};

    const itemRender = (item, search) => {
        item.dataName = '';
        if (prFulltext.params.length > 0 && prFulltext.params.includes('anchor')) {
            item.dataName = item.url.replace('/', '#');
            item.url = '';
        }
        search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        let re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
        return '<div class="autocomplete-suggestion globalsearch-result" data-name="' + item.dataName + '" data-url="'+ item.url +'" data-val="' + search + '">' + item.textLabel.replace(re, "<b>$1</b>") + '</div>';
    }

    const processDataForAutocomplete = (responseJson) => {
        let responseData = responseJson;
        if(responseJson.items.length === 0)
            responseData = emptyData;

        return responseData.items;
    }

    const getSource = (term, response) => {
        if (xhr) {
            xhr.abort();
        }

        const query = new URLSearchParams();
        query.append("term", term);
        if (prFulltext.modules.length) {
            prFulltext.modules.forEach(module => {
                query.append("modules[]", module)
            });
        }

        xhr = new XMLHttpRequest();
        xhr.open('GET', '/hledani.json?' + query.toString(), true);

        xhr.onload = () => {
            let sourceData;
            if (xhr.status >= 200 && xhr.status < 400) {
                sourceData = JSON.parse(xhr.responseText);
            } else {
                sourceData = errorData;
            }

            response(processDataForAutocomplete(sourceData));
        };
        xhr.onerror = () => { response(processDataForAutocomplete(errorData)) }
        xhr.send();
    }

    const onItemSelect = (e, term, item) => {
        let url = item.getAttribute('data-url');
        let name = item.getAttribute('data-name');

        e.preventDefault();
        if (url === '' && name === '') {
            return;
        }

        if (url !== '') {
            url = ('/' + url).replace(/^\/+/g, '/');
            window.location = url;
        } else if (name !== '') {
            name = name.replace(/^\/+/g, '');
            const nameBtn = document.querySelector(name);
            if (nameBtn) {
                nameBtn.scrollIntoView({behavior: "smooth"}, true);
            }
        }
    }

    /**
     * Default settings
     */
    const defaultOpts = {
        minChars: 3,
        renderItem: itemRender,
        source: getSource,
        onSelect: onItemSelect
    };

    prFulltext.init = (selector, modules = [], params = [], settings = {}) => {
        options = {...defaultOpts, ...settings, ...{selector: selector}}
        prFulltext.modules = modules;
        prFulltext.params = params;
        prFulltext.autoComplete = new autoComplete(options);
    }

    prFulltext.destroy = () => {
        prFulltext.autoComplete.destroy();
    }

    return prFulltext;
});